"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _dotPropImmutable = _interopRequireDefault(require("dot-prop-immutable"));

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = {
  values: {},
  errors: [],
  isDirty: false,
  isPristine: true,
  isValid: false
};
var SET_STATE = 'SET_STATE';
var SET_VALUE = 'SET_VALUE';
var UPDATE_VALUES = 'UPDATE_VALUES';
var UPDATE_ERRORS = 'UPDATE_ERRORS';
var VALIDATE = 'VALIDATE';
var RESET_FORM = 'RESET_FORM';

var reducer = function reducer(state, action) {
  var validation = state.validation,
      validationOptions = state.validationOptions;

  switch (action.type) {
    case SET_VALUE:
      {
        var key = action.key,
            value = action.value;

        var newState = _dotPropImmutable["default"].set(state, "values.".concat(key), value);

        if (!newState.isPristine) {
          var newErrors = validation(newState.values, validationOptions);
          newState = _dotPropImmutable["default"].set(newState, 'errors', newErrors);
        }

        return _objectSpread({}, newState, {
          isDirty: true
        });
      }

    case UPDATE_VALUES:
      {
        var values = action.values;

        var newValues = _objectSpread({}, state.values, {}, values);

        var _newState = _dotPropImmutable["default"].set(state, 'values', newValues);

        var _newErrors = [];

        if (!state.isPristine) {
          _newErrors = validation(_newState.values, validationOptions);
        }

        _newState = _dotPropImmutable["default"].set(_newState, 'errors', _newErrors);
        return _objectSpread({}, _newState, {
          isDirty: true
        });
      }

    case UPDATE_ERRORS:
      {
        var errors = action.errors;
        return _dotPropImmutable["default"].set(state, 'errors', errors);
      }

    case VALIDATE:
      {
        var _errors = validation(state.values, validationOptions);

        var isValid = (0, _utils.containsNoErrors)(_errors);
        return _objectSpread({}, state, {
          isPristine: false,
          isValid: isValid,
          errors: _errors
        });
      }

    case RESET_FORM:
      {
        var initialValues = action.initialValues,
            initialValidation = action.initialValidation;
        var _errors2 = [];
        return _objectSpread({}, INITIAL_STATE, {
          values: initialValues,
          validation: initialValidation,
          errors: _errors2
        });
      }

    case SET_STATE:
      {
        return action.state;
      }

    default:
      throw new Error("Unknown form state action '".concat(action.type, "'."));
  }
};

var useFormState = function useFormState() {
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$validation = options.validation,
      validation = _options$validation === void 0 ? function () {
    return [];
  } : _options$validation,
      validationOptions = options.validationOptions,
      _valuesToInput = options.valuesToInput,
      _options$debug = options.debug,
      debug = _options$debug === void 0 ? false : _options$debug;

  var initialState = _objectSpread({}, INITIAL_STATE, {
    values: initialValues,
    validation: validation,
    validationOptions: validationOptions
  });

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  (0, _useDeepCompareEffect["default"])(function () {
    var initialValuesClone = (0, _lodash["default"])(initialValues);
    dispatch({
      type: SET_STATE,
      state: _objectSpread({}, INITIAL_STATE, {
        values: initialValuesClone,
        validation: validation,
        validationOptions: validationOptions
      })
    });
  }, [initialValues, validationOptions]);

  if (debug) {
    // eslint-disable-next-line no-console
    console.log(state);
  }

  var resetForm = function resetForm() {
    dispatch({
      type: RESET_FORM,
      initialValues: initialValues,
      initialValidation: validation,
      initialValidationOptions: validationOptions,
      errors: []
    });
  };

  var setErrors = function setErrors(errors) {
    dispatch({
      type: UPDATE_ERRORS,
      errors: errors
    });
  };

  var setValues = function setValues(values) {
    dispatch({
      type: UPDATE_VALUES,
      values: values
    });
  };

  var setValue = function setValue(key, value) {
    dispatch({
      type: SET_VALUE,
      key: key,
      value: value
    });
  };

  var handleNativeChange = function handleNativeChange(e) {
    var _e$target = e.target,
        name = _e$target.name,
        type = _e$target.type,
        value = _e$target.value,
        checked = _e$target.checked,
        files = _e$target.files;
    var finalValue = value;

    if (type === 'checkbox') {
      finalValue = checked;
    } else if (type === 'file') {
      var _files = _slicedToArray(files, 1);

      finalValue = _files[0];
    }

    setValue(name, finalValue);
  };

  var validate = function validate() {
    var errors = validation(state.values, validationOptions);
    var isValid = (0, _utils.containsNoErrors)(errors);
    dispatch({
      type: VALIDATE
    });
    return isValid;
  };

  var getValue = function getValue(path) {
    return _dotPropImmutable["default"].get(state.values, path, '');
  };

  var getErrorMessages = function getErrorMessages(path) {
    return state.errors.filter(function (error) {
      return error.path === path;
    }).map(function (_ref) {
      var message = _ref.message;
      return message;
    });
  };

  var hasError = function hasError(path) {
    return typeof state.errors.find(function (error) {
      return error.path === path;
    }) !== 'undefined';
  };

  var getNativeInputProps = function getNativeInputProps(path) {
    return {
      value: getValue(path),
      hasError: hasError(path),
      onChange: handleNativeChange,
      name: path
    };
  };

  var getInputProps = function getInputProps(path) {
    return {
      value: getValue(path),
      hasError: hasError(path),
      onChange: function onChange(value) {
        return setValue(path, value);
      },
      name: path
    };
  };

  return {
    errors: state.errors,
    values: state.values,
    isDirty: state.isDirty,
    isValid: state.isValid,
    isPristine: state.isPristine,
    setValues: setValues,
    handleChange: setValue,
    handleNativeChange: handleNativeChange,
    validate: validate,
    updateErrors: setErrors,
    resetForm: resetForm,
    getInputProps: getInputProps,
    getNativeInputProps: getNativeInputProps,
    valuesToInput: function valuesToInput() {
      return _valuesToInput(state.values);
    },
    getValue: getValue,
    getErrorMessages: getErrorMessages,
    hasError: hasError
  };
};

var _default = useFormState;
exports["default"] = _default;